var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{ref:"tag",tag:"domel",staticClass:"rest-placeholder rich-text",domProps:{"innerHTML":_vm._s(_vm.filteredHtml)}},[_vm._t("default")],2)}]

export { render, staticRenderFns }